import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { environment } from '../../environments/environment';
import { Respuesta } from '../entities/respuesta.entity';
import { SessionService } from '../services/session.service';
import { UserService } from '../services/user.service';
import { UploadFileComponent } from './Components/uploadfile.component';

export interface FormModel { captcha?: string; }

@Component({
  selector: 'app-tramites',
  templateUrl: './tramites.component.html'
})
export class TramitesComponent implements OnInit {
  data = [
    {
      titulo : 'SOLICITUD ALTA DE BATERIA',
      descripcion : 'Una vez tramitada la contratación del contador general se puede optar por dar de alta los contadores ' +
        'divisionarios con el objeto de que sea facturado el consumo de cada inmueble del edificio de forma individual.'
    },
    {
      titulo : 'SOLICITUD ALTA DECLARACIÓN DE USUARIOS',
      descripcion : 'Una vez tramitada la contratación del contador general y en caso de no existir posibilidad de dar de ' +
        'alta batería de contadores, se han de declarar el número de usuarios que dependen de la acometida del edificio.'
    },
    {
      titulo : 'SOLICITUD REENGANCHE',
      descripcion : 'Restablecimiento del suministro cortado.'
    },
    {
      titulo : 'SOLICITUD BAJA DEL SUMINISTRO',
      descripcion : 'Baja en el suministro, lo que implica el corte de este.'
    },
    {
      titulo : 'SOLICITUD CAMBIO DE NOMBRE',
      descripcion : 'Solicita efectuar el Cambio de Nombre del Contrato de Suministro de Agua.'
    },
    {
      titulo : 'SOLICITUD ALTA DE ACOMETIDA',
      descripcion : 'Solicita la concesión del permiso para efectuar la Acometida de Agua a la vivienda.'
    }
  ];
  public formModel: FormModel = {};
  public keyCaptchaSite: string;
  public captchaError: boolean;
  public files: File[] = [];
  public attachments: File[] = [];
  public name: string;
  public dni: string;
  public resultado: Respuesta;
  public messageCabecera: string;
  public messageComplet: string;
  public typeException: number;
  public idDoc = 0;
  @ViewChildren(UploadFileComponent) childs: QueryList<UploadFileComponent>;

  constructor( private sessionService: SessionService, private userService: UserService ) { }

  ngOnInit() {
    this.keyCaptchaSite = environment.capchasiteKey;
  }

  downloadFile(solId: number) {
    const link = document.createElement('a');
    switch (solId) {
      case 0:
        link.download = 'SOLICITUD_ALTA_BATERIA';
        link.href = 'assets/documents/SOL_ALTABATERIA.pdf';
      break;
      case 1:
        link.download = 'SOLICITUD_ALTA_DECLARACION_USUARIOS';
        link.href = 'assets/documents/SOL_ALTADECLARACIONUSUARIOS.pdf';
      break;
      case 2:
        link.download = 'SOLICITUD_REENGANCHE';
        link.href = 'assets/documents/SOL_REENGANCHE.pdf';
      break;
      case 3:
        link.download = 'SOLICITUD_BAJA_SUMINISTRO';
        link.href = 'assets/documents/SOL_BAJASUMINISTRO.pdf';
      break;
      case 4:
        link.download = 'SOLICITUD_CAMBIO_NOMBRE';
        link.href = 'assets/documents/SOL_CAMBIONOMBRE.pdf';
      break;
      case 5:
        link.download = 'SOLICITUD_ALTA_ENGANCHE';
        link.href = 'assets/documents/SOL_ALTAENGANCHE.pdf';
      break;
    }
    link.click();
    this.idDoc = solId;
  }

  public async enviarDocumento() {
    this.clearInputErrors();
    const formData: FormData = new FormData();
    this.files = this.sessionService.files;
    this.attachments = this.sessionService.attachments;
    if (this.formModel.captcha === undefined) {
      this.captchaError = this.formModel.captcha === undefined ? true : false;
    }
    if (this.files.length === 1 && this.attachments.length > 0 && this.formModel.captcha !== undefined) {
      formData.append('procedure', this.files[0], this.files[0].name);
      for (let j = 0; j < this.attachments.length; j++) {
        formData.append('attachments', this.attachments[j], 'attachment0' + j);
      }
      formData.append('Nombre', this.sessionService.nombre);
      formData.append('Nif', this.sessionService.login);
      formData.append('EMail', this.sessionService.email);
      formData.append('Telefono', this.sessionService.telefono);
      formData.append('Contrato', this.sessionService.contratoSelected.Codigo.toString());
      formData.append('Direccion', this.sessionService.contratoSelected.InmuebleBO.Direccion);
      formData.append('ModoTest', this.sessionService.usuario.ModoTest === undefined ? false.toString() :
        this.sessionService.usuario.ModoTest.toString());
      formData.append('gRecaptchaResponse', this.formModel.captcha);
      switch (this.idDoc) {
        case 0:
          formData.append('TipoDoc', 'solAltaBat');
        break;
        case 1:
          formData.append('TipoDoc', 'solAltaDec');
        break;
        case 2:
          formData.append('TipoDoc', 'solReeng');
        break;
        case 3:
          formData.append('TipoDoc', 'baja');
        break;
        case 4:
          formData.append('TipoDoc', 'solCamNom');
        break;
        case 5:
          formData.append('TipoDoc', 'solAltaEng');
        break;
      }
      this.userService.uploadSolicitud(this.sessionService.explotacion, formData).subscribe(
        response => this.uploadOnSuccess(response),
        response => this.uploadOnError(response)
      );
      this.closeModal();
    } else {
      if (this.files.length === 0) {
        this.childs.first.errors.push('Debe seleccionar el PDF del trámite');
      }
      if (this.attachments.length === 0) {
        this.childs.last.errors.push('Debe seleccionar los PDF adjuntos');
      }
    }
  }

  public uploadOnSuccess(response: Respuesta) {
    this.messageCabecera = 'Trámite enviado';
    this.messageComplet = 'El trámite se ha enviado correctamente';
    this.typeException = 2;
  }

  public uploadOnError(response: Respuesta) {
    this.resultado = response;
    this.formModel.captcha = null;
    this.messageCabecera = 'Error en el envío';
    if (this.resultado.Ex !== undefined) {
      this.messageComplet = this.resultado.Ex.Message;
      this.typeException = this.resultado.TipoExcepcion;
    } else {
      this.messageComplet = 'Se ha producido un error en el envío del trámite';
      this.typeException = 1;
    }
  }

  public clearInputErrors() {
    this.captchaError = false;
    this.messageCabecera = '';
    this.messageComplet = '';
    this.typeException = -1;
    this.childs.forEach(c => c.errors = []);
  }

  closeModal() {
    this.files = [];
    this.attachments = [];
    this.sessionService.files = [];
    this.sessionService.attachments = [];
    grecaptcha.reset();
    this.childs.forEach(c => {
      c.reset();
      c.errors = [];
    });
    ($('#modal-subida') as any).modal('hide');
    this.captchaError = false;
    this.formModel.captcha = undefined;
  }

}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/home/tramites.component.ts